<div class="login-form-wrapper mt-auto">
  <img src="assets/images/rne-logo.svg" class="login-form-logo" alt="RailNet Europe - Path Coordination System"/>

  <form [formGroup]="form" (submit)="onSubmit()">
    <div class="d-flex flex-column gap-3">
    <pcs-input
      name="username"
      label="Username"
      inputId="username"
      placeholder="enter your username"
      [horizontal]="false"
      formControlName="username"
      (changed)="changed.emit()"
      class="w-100">
    </pcs-input>
    <pcs-input
      name="password"
      label="Password"
      type="password"
      inputId="password"
      placeholder="enter your password"
      [horizontal]="false"
      formControlName="password"
      (changed)="changed.emit()"
      class="w-100">
    </pcs-input>
    <pcs-button
      type="submit"
      buttonText="Log in"
      buttonStyle="primary"
      [disabled]="!isValid()">
    </pcs-button>
    </div>
  </form>
  <ul class="text-center">
    <li class="list-inline-item">
      <a href="{{requestNewAccountUrl}}" title="Request new account" target="_blank">
        Request new account
      </a>
    </li>
    <li class="list-inline-item">
      <a href="{{requestPasswordChangeUrl}}" title="Request password change" target="_blank">
        Request password change
      </a>
    </li>
  </ul>
</div>

<div class="login-form-footer mt-auto">
  <p class="pcs-support-link">Questions or comments? Please contact
    <a href="mailto:{{mailPcsSupport}}" title="Contact PCS Support"> PCS Support</a>.
  </p>
  <ul class="list-inline-item">
    <li class="list-inline-item">
      <a [href]="ipDocumentation" target="_blank">
        PCS IP Documentation
      </a>
    </li>
    <li class="list-inline-item">
      <a [href]="documentation" target="_blank">
        PCS Documentation
      </a>
    </li>
  </ul>
  <a href="https://ec.europa.eu/transport/themes/infrastructure_en" target="_blank">
    <img src="assets/images/cef_logo.svg" alt="European Union"/>
  </a>

</div>
